/* src/app/expenses/presenters/expense-pdbo/expense-pdbo.component.scss */
:host {
  overflow: hidden;
  height: 85vh;
}
:host .title-case {
  text-transform: capitalize;
}
:host mat-dialog-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
  overflow: hidden;
  height: 80vh;
  width: 75vw;
}
:host mat-dialog-content p-header {
  height: 3rem;
  display: block;
  text-align: center;
}
:host mat-dialog-content p-header::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  display: block;
  clear: both;
  background-color: #ccc;
  margin-top: 1em;
}
:host mat-dialog-content p-footer {
  height: 3rem;
}
:host mat-dialog-content p-footer::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  display: block;
  clear: both;
  background-color: #ccc;
  margin-top: -1em;
}
:host mat-dialog-content p-footer > div {
  display: flex;
  flex-flow: row-reverse;
}
/*# sourceMappingURL=expense-pdbo.component.css.map */
